import React, { useState } from 'react';
import { IconButton, ListItemIcon, Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  DeleteBlackIcon,
  MoreIcon,
  ReloadIcon
} from '@components/icons/svg-icon.tsx';
import { GroupActionsProps } from '@modules/digital-signage/model/group-settings.model.ts';

const GroupActions: React.FC<GroupActionsProps> = ({ onReload, onDelete }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleAction = (action: () => void) => {
    setAnchorEl(null);
    action();
  };

  return (
    <>
      <IconButton
        className="p-0! h-5! w-5!"
        disableRipple
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <MoreIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        className="min-w-50"
      >
        <MenuItem onClick={() => handleAction(onReload)}>
          <ListItemIcon className="min-w-7.5! h-7.5 rounded-full bg-(--gray-11) flex justify-center items-center">
            <ReloadIcon strokeOpacity={1} />
          </ListItemIcon>
          {t('reload_group')}
        </MenuItem>
        <MenuItem onClick={() => handleAction(onDelete)}>
          <ListItemIcon className="min-w-7.5! h-7.5 rounded-full bg-(--gray-11) flex justify-center items-center">
            <DeleteBlackIcon />
          </ListItemIcon>
          {t('delete_group')}
        </MenuItem>
      </Menu>
    </>
  );
};

export default GroupActions;
